import { GraviGrid } from '@gravitate-js/excalibrr'
import type React from 'react'

import type { TransactionDetail } from '../../../api/useFreight/types'
import { getColumnDefs } from '../shared/LineItems/flatViewLineItemColumns'
import type { GridApi } from 'ag-grid-community'
import type { MutableRefObject } from 'react'
import type { GridConfigState } from '@gravitate-js/excalibrr/dist/components/GraviGrid/hooks/useAGGridEvent'
import { useSecurityContext } from '../../Navigation/SecurityContext'

interface FlatViewProps {
  actionButtons: React.ReactNode
  gridAPIRef: MutableRefObject<GridApi>
  filteredData: TransactionDetail[]
  updateSetting: (key: string, value: GridConfigState) => void
  isLoading: boolean
  // @ts-ignore
  serverParams: Record<string, unknown>
  setServerFilters: (filters: Record<string, unknown>) => void
  // @ts-ignore
  filters: Record<string, unknown>
}

export function FlatView({
  actionButtons,
  gridAPIRef,
  filteredData,
  updateSetting,
  isLoading,
  serverParams,
  setServerFilters,
  filters,
}: FlatViewProps) {
  const { scopes } = useSecurityContext()
  return (
    <GraviGrid
      controlBarProps={{
        title: 'Freight Line Items',
        actionButtons,
        // @ts-ignore
        serverParams,
        setFilters: setServerFilters,
        // @ts-ignore
        filters,
      }}
      columnDefs={getColumnDefs()}
      rowData={filteredData}
      loading={isLoading}
      externalRef={gridAPIRef}
      storageKey='freight-line-items-flat'
      onGridConfigChanged={(config: GridConfigState) => updateSetting('gridConfig::freight-line-items-flat', config)}
      agPropOverrides={{
        context: {
          scopes,
        },
        domLayout: 'normal',
        rowGroupPanelShow: 'always',
        groupDisplayType: 'groupRows',
        suppressRowTransform: true,
        rowSelection: 'multiple',
        enableRangeSelection: true,
        rowHeight: 40,
        getRowId: (params) => params.data.id,
        animateRows: true,
        suppressMaintainUnsortedOrder: false,
      }}
    />
  )
}
